import {Axios} from '../axios/axios.js'
//quick match add new task by scan
export const firstAddNewQiickHandle = (e) => {
  return Axios({
    url:'task/quick_task_setp1',
    method:"put",
    data:e
  })
}
export const secondAddNewQiickHandle = (e) => {
  return Axios({
    url:'task/quick_task_setp2',
    method:"put",
    data:e
  })
}
export const thirdAddNewQiickHandle = (e) => {
  return Axios({
    url:'task/quick_task_setp3',
    method:"put",
    data:e
  })
}
